import { Grid } from '@mui/material';
import { HSpacer, RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { NodeRendererProps } from 'react-arborist';
import styled from 'styled-components';

import { TreeApiData } from '..';
import { RightArrowIcon } from '../../../../../../../assets/svg/RightArrowIcon';
import Text from '../../../../../../../react-components/Text';
import { useRetrieveActivePlanStops } from '../../../../hooks/plan-details/useRetrieveActivePlanStops';
import { TREE_ITEM_HEIGHT } from '../PlanOverviewListStyles';

interface UnassignedChipContainerProps {
  isSelected?: boolean;
  isDraggingOver?: boolean;
}

const UnassignedChipContainer = styled(Grid)`
  height: ${TREE_ITEM_HEIGHT}px;
  border-left: 1px solid ${RoutalPalette.neutral10};
  padding: 3px 10px 3px 4px !important;
  cursor: pointer;
  // background-color: ${RoutalPalette.neutral02n};
  background-color: ${({ isSelected }: UnassignedChipContainerProps) =>
    isSelected ? RoutalPalette.neutral05 : RoutalPalette.neutral00};
  & *: cursor: pointer;
  :after {
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    z-index: 100;
    ${({ isDraggingOver }: UnassignedChipContainerProps) => {
      if (isDraggingOver) {
        return `
          bottom: -1px;
          height: 2px;
          background-color: ${RoutalPalette.primary20};
        `;
      }

      return `
        bottom: 0;
        height: 1px;
        background-color: ${RoutalPalette.neutral10};
      `;
    }}
  }
`;

interface UnassignedElementProps extends NodeRendererProps<TreeApiData> {
  selectedStops: string[];
}

export const UnassignedElement = ({ selectedStops, node, style, dragHandle }: UnassignedElementProps) => {
  const { data: stops } = useRetrieveActivePlanStops();

  const unassignedStopsIds = stops?.filter((stop) => !stop.driver_id).map((stop) => stop.id) ?? [];

  const isExpanded = node.isOpen;
  node.isDraggable = false;

  const isSelected = selectedStops.some((stopId) => unassignedStopsIds.includes(stopId));

  const isDraggingOver = node.willReceiveDrop;

  return (
    <UnassignedChipContainer
      container
      alignContent="center"
      justifyContent="space-between"
      alignItems="center"
      wrap="nowrap"
      style={{
        ...style,
      }}
      isSelected={isSelected}
      isDraggingOver={isDraggingOver}
      ref={dragHandle}
      onClick={() => node.toggle()}
    >
      <Grid
        container
        direction="column"
        style={{
          width: `100%`,
          padding: `0 10px`,
        }}
      >
        <Text
          intlId="planoverview.unassigned"
          style={{ color: RoutalPalette.secondary00, fontSize: `13px`, cursor: `pointer`, fontWeight: 500 }}
        />
        <VSpacer small />
        <Text
          intlId="planoverview.unassigned_stops"
          intlValues={{ num: unassignedStopsIds.length }}
          style={{ color: RoutalPalette.neutral20, fontSize: `12px`, cursor: `pointer` }}
        />
        <HSpacer small />
      </Grid>

      <Grid
        item
        style={{
          height: `100%`,
          minWidth: `16px`,
          alignContent: `center`,
        }}
      >
        {isExpanded ? (
          <RightArrowIcon
            style={{
              color: RoutalPalette.secondary60,
              transform: `rotate(90deg)`,
            }}
          />
        ) : (
          <RightArrowIcon
            style={{
              color: RoutalPalette.secondary60,
            }}
          />
        )}
      </Grid>
    </UnassignedChipContainer>
  );
};
